import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { ChatThread } from "@/components/ChatThread";
import { fmtDate, place } from "@/lib/format";
import { UserUsage } from "@/components/UserUsage";

const Row = ({ k, v, testid }) => (
  <div className="flex gap-4 py-2 border-b rf-line text-sm">
    <span className="w-32 shrink-0 rf-mono text-[10px] tracking-wider uppercase text-[var(--rf-grey)] pt-0.5">{k}</span>
    <span className="min-w-0 break-words" data-testid={testid}>{v || "—"}</span>
  </div>
);

export const AdminUserPanel = ({ user, onRead }) => {
  const [messages, setMessages] = useState([]);
  const load = useCallback(() => api.get(`/admin/chat/${user.id}`).then((r) => setMessages(r.data)).catch(() => {}), [user.id]);

  const onReadRef = useRef(onRead);
  onReadRef.current = onRead;

  useEffect(() => {
    setMessages([]);
    load().then(() => onReadRef.current?.());
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [load]);

  const send = async (text) => {
    const { data } = await api.post(`/admin/chat/${user.id}`, { text });
    setMessages((m) => [...m, data]);
  };

  const s = user.source || {};
  return (
    <div className="space-y-8 rf-fade" data-testid="admin-user-panel">
      <div className="border-t border-[var(--rf-ink)] pt-4">
        <h2 className="text-lg font-bold truncate" data-testid="admin-user-email">{user.email}</h2>
        <p className="text-sm text-[var(--rf-grey)]">{user.name || "Senza nome"}</p>
        <div className="mt-4">
          <Row k="Provenienza" v={s.label} testid="admin-user-source" />
          <Row k="Referrer" v={s.referrer} />
          <Row k="Campagna" v={[s.utm_source, s.utm_medium, s.utm_campaign].filter(Boolean).join(" / ")} />
          <Row k="Pagina d'arrivo" v={s.landing} />
          <Row k="Luogo (IP)" v={place(user.geo)} testid="admin-user-geo" />
          <Row k="IP iscrizione" v={user.signup_ip} testid="admin-user-signup-ip" />
          <Row k="Ultimo IP" v={user.last_ip} />
          <Row k={`IP unici (${user.unique_ips})`} v={(user.ips || []).filter(Boolean).join(", ")} testid="admin-user-ips" />
          <Row k="Dispositivo" v={user.device} testid="admin-user-device" />
          <Row k="Analisi" v={String(user.analyses)} />
          <Row k="Ultimo accesso" v={fmtDate(user.last_login)} />
          <Row k="Ultima attività" v={fmtDate(user.last_seen)} />
          <Row k="Iscritto il" v={fmtDate(user.created_at)} />
        </div>
      </div>
      <UserUsage user={user} />
      <div className="border border-[var(--rf-ink)] h-[460px] flex flex-col">
        <div className="px-4 h-12 flex items-center border-b border-[var(--rf-ink)] font-bold text-sm">Chat con {user.name || user.email}</div>
        <ChatThread messages={messages} me="admin" onSend={send} className="flex-1" emptyText="Nessun messaggio. Scrivi tu per primo." />
      </div>
    </div>
  );
};
